module.exports = __webpack_public_path__ + "img/tree-3.7aef7cb6.png";